import * as jsxRuntime from "D:\\xampp2021\\htdocs\\unismuh\\sispenmu\\lanading-page\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment